(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Transaction.Capture.Finances.Summary",
                {
                    url: "/Summary",
                    component: "financesSummary",
                    resolve: {

                    },
                    onEnter: ["transaction", "transactionApi", function(transaction, transactionApi) {
                        transaction.LastTransactionStage = "Finances";
                        transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                    }]
                });
        }
    ]);

    app.component("financesSummary",
        {
            templateUrl: "/App/Transaction/Capture/Finances/Summary/summary-template.html",
            controller: financesSummaryController,
            bindings: {
                transaction: "<",
                finance: "<",
                otherMonthlyIncomes: "<",
                otherMonthlyExpenses: "<",
                otherAssets: "<",
                otherLiabilities: "<",
                prevStage: "<",
                nextStage: "<"
            }
        });

    financesSummaryController.$inject = [];
    function financesSummaryController() {
        var $ctrl = this;

        ng.extend($ctrl,
            {

            });

        this.$onInit = function() {
            $ctrl.totalIncome = 0;
            $ctrl.totalExpenses = 0;
            $ctrl.totalAssets = 0;
            $ctrl.totalLiabilities = 0;

            if ($ctrl.finance) {
                ng.forEach($ctrl.finance.MonthlyIncomes,
                    function (income) {
                        if (income)
                            $ctrl.totalIncome += income;
                    });
                ng.forEach($ctrl.otherMonthlyIncomes,
                    function (income) {
                        if (income.Value)
                            $ctrl.totalIncome += income.Value;
                    });

                ng.forEach($ctrl.finance.MonthlyExpenses,
                    function (expense) {
                        if (expense)
                            $ctrl.totalExpenses += expense;
                    });
                ng.forEach($ctrl.otherMonthlyExpenses,
                    function (expense) {
                        if (expense.Value)
                            $ctrl.totalExpenses += expense.Value;
                    });

                ng.forEach($ctrl.finance.Assets,
                    function (asset) {
                        if (asset)
                            $ctrl.totalAssets += asset;
                    });
                ng.forEach($ctrl.otherAssets,
                    function (asset) {
                        if (asset.Value)
                            $ctrl.totalAssets += asset.Value;
                    });

                ng.forEach($ctrl.finance.Liabilities,
                    function (liability) {
                        if (liability)
                            $ctrl.totalLiabilities += liability;
                    });
                ng.forEach($ctrl.otherLiabilities,
                    function (liability) {
                        if (liability.Value)
                            $ctrl.totalLiabilities += liability.Value;
                    });
            }

            $ctrl.totalIncome = parseFloat($ctrl.totalIncome.toFixed(2));
            $ctrl.totalExpenses = parseFloat($ctrl.totalExpenses.toFixed(2));
            $ctrl.totalAssets = parseFloat($ctrl.totalAssets.toFixed(2));
            $ctrl.totalLiabilities = parseFloat($ctrl.totalLiabilities.toFixed(2));

        };
    };

})(window.app, window.angular);